import { FC } from 'react';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export const MovieCardSkeleton: FC = () => {
  return (
    <Stack
      spacing={3}
      padding={2}
      sx={{
        width: '100%',
        height: '100%',
        borderRadius: '20px',
      }}
    >
      <Skeleton
        variant='rectangular'
        sx={{
          width: '100%',
          height: {
            mobile: '198.63px',
            tablet: '290px',
            laptop: '380px',
          },
          borderRadius: '20px',
        }}
      />
      <Stack spacing={2}>
        <Skeleton variant='text' width='90%' height='35px' />

        <Stack spacing={1} direction='row'>
          <Skeleton variant='text' width='40px' />
          <Skeleton variant='text' width='40px' />
          <Skeleton variant='text' width='40px' />
        </Stack>
      </Stack>
    </Stack>
  );
};
